import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import styled from '@emotion/styled';

export const DropdownOption = (props:any) =>{
    const index = props.index;
    const menuIndex = props.menuIndex;
    const setMenuIndex = props.setMenuIndex;
    const options = props.options;
    const onChange = props.onChange;
    const user = props.user;
    
    const handleClick = () => {
      if(menuIndex == index){
        setMenuIndex(null);
        return;
      }
      setMenuIndex(index);
    }
  
    return (
        <DropdownOptionContainer onClick={handleClick} className={index == menuIndex ? 'active' : ''}>
            <span><MoreIcon/></span>
            {index == menuIndex ?<OptionContainer>
            {options?.length > 0 ? options.map((eOption:string) => <span key={eOption} onClick={() => onChange(eOption, user)}>{eOption}</span>) : ''}
            </OptionContainer>:''}
        </DropdownOptionContainer>
    )
}

const DropdownOptionContainer  = styled.span`
  position: relative;
  z-index: 10;
  padding:8px;
  background-color:#11643C;
  cursor: pointer;
  color:#fff;
  height:20px;
  display:none;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 3px;
  width:30px;
  &.active{
    display:flex !important;
  }

` 

export const OptionContainer = styled.div`
  position: absolute;
  top:20px;
  right:0;
  z-index: 100;
  background-color: #fff;
  border:1px solid #eee;
  width:170px;
  padding:10px 0;
  display:flex;
  flex-direction: column;
  & > span{
    flex:1;
    padding:10px !important;
    color:#222;
    cursor:pointer;
  }
  & > span:hover{
    background-color: #F1F1F1;
  }
`